class VideoControl extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.video = this.querySelector("video");
    this.videoPlayPauseButton = this.querySelector("[data-play-pause-button]");
    this.videoMuteButton = this.querySelector("[data-mute-unmute-button]");

    this.video.addEventListener("play", () => {
      this.setAttribute("state", "playing");
    });

    this.video.addEventListener("pause", () => {
      this.setAttribute("state", "paused");
    });

    const play = async () => {
      try {
        await this.video.play();
      } catch (err) {
        console.warn(err);
      }
    };

    if (this.videoPlayPauseButton) {
      this.videoPlayPauseButton.addEventListener("click", () => {
        this.video.paused ? play() : this.video.pause();
      });
    }

    this.setAttribute("muted", this.video.muted ? "true" : "false");

    this.video.addEventListener("volumechange", () => {
      this.setAttribute("muted", this.video.muted ? "true" : "false");
    });

    if (this.videoMuteButton) {
      this.videoMuteButton.addEventListener("click", () => {
        this.video.muted = !this.video.muted;
      });
    }
  }

  disconnectedCallback() {}
}

if (!customElements.get("video-control")) {
  customElements.define("video-control", VideoControl);
}
